import { useMemo } from "react";
import type { TranscriptRecord } from "../types";
import type { SalesJson } from "./documentTypes/spicedSales";
// import { Row, Col } from "react-bootstrap";
import { css } from "../../../../styled-system/css";

const SalesBox = ({ transcriptData, expanded }: { transcriptData: TranscriptRecord[]; expanded: boolean }) => {
  const salesSummary: SalesJson | undefined = useMemo(() => {
    const summaryItems = transcriptData.filter((item) => item.type === "spiced_sales_summary");

    if (summaryItems.length === 0) {
      return undefined;
    }
    try {
      if (summaryItems[0]?.content) {
        return JSON.parse(summaryItems[0].content) as SalesJson;
      }
      return undefined;
    } catch {
      return undefined;
    }
  }, [transcriptData]);

  if (!salesSummary) {
    return <div>No Sales summary found</div>;
  }

  return (
    <div className={css({ fontSize: "medium" })}>
      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Situation</div>
        <div>{salesSummary.situation.summary || "N/A"}</div>
        <div className={css({ paddingTop: "1rem" })}>{salesSummary.overall_notes || "N/A"}</div>
      </div>

      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Pain</div>
        <div>{salesSummary.pain.primary_pain || "N/A"}</div>
      </div>
      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Impact</div>
        <div>{salesSummary.impact.summary || "N/A"}</div>
        {salesSummary.impact.quantification && (
          <div>
            <em>
              <strong>Quantification: </strong>
              {salesSummary.impact.quantification}
            </em>
          </div>
        )}
      </div>
      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Critical Event</div>
        <div>{salesSummary.critical_event.description || "N/A"}</div>
      </div>
      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Decision Maker</div>
        <div>
          {salesSummary.economic_buyer.name || "N/A"}

          {salesSummary.economic_buyer.name !== null && salesSummary.economic_buyer.title && (
            <span>({salesSummary.economic_buyer.title})</span>
          )}
        </div>
      </div>
      <div className={css({ marginBottom: "1rem" })}>
        <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Decision Process</div>
        <div className={css({ display: "flex" })}>
          <div className={css({ flex: 1, padding: "0.5rem" })}>
            <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Steps</div>
            <ul>
              {salesSummary.decision_process.steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>

            <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Timeline</div>
            <div>{salesSummary.decision_process.timeline || "N/A"}</div>
          </div>

          <div className={css({ flex: 1, padding: "0.5rem" })}>
            <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Procurement Requirements</div>
            <ul>
              {salesSummary.decision_process.procurement_requirements.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>

            <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Stakeholders</div>
            <ul>
              {salesSummary.decision_process.stakeholders.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {expanded && (
        <div>
          <div className={css({ marginBottom: "1rem" })}>
            <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Customer Goals</div>
            <div>
              {salesSummary.customer_goals.summary || "N/A"}

              <ul>
                {salesSummary.customer_goals.metrics.map((metric, index) => (
                  <li key={index}>{metric}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className={css({ marginBottom: "1rem" })}>
            <div className={css({ display: "flex", flexWrap: "wrap" })}>
              <div className={css({ flex: 1, padding: "0.5rem" })}>
                <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Objection Handling</div>
                <div>
                  <ul>
                    {salesSummary.objection_handling.objections.map((metric, index) => (
                      <li key={index}>{metric}</li>
                    ))}
                  </ul>
                </div>

                <div className={`fs-standard fw-bold`}>Possible Solutions</div>
                <div>
                  <ul>
                    {salesSummary.objection_handling.recommended_responses.map((metric, index) => (
                      <li key={index}>{metric}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={css({ flex: 1, padding: "0.5rem" })}>
                <div className={css({ fontSize: "2xl", fontWeight: "bold" })}>Open Questions</div>
                <div>
                  <ul>
                    {salesSummary.open_questions.map((metric, index) => (
                      <li key={index}>{metric}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesBox;
